module.exports = __webpack_public_path__ + "static/media/background_640-1.1420d15b.jpg";